import {
    LOAD_CARDS_SUCCEEDED,
    REMOVE_CREDIT_CARD_SUCCEEDED
} from '../constants/action-types';

export const loadCardsSucceeded = data => ({
    type: LOAD_CARDS_SUCCEEDED,
    payload: data
});

export const removeCreditCardSucceeded = registrationId => ({
    type: REMOVE_CREDIT_CARD_SUCCEEDED,
    registrationId
});
